(function ($, Drupal) {
  'use strict';
  Drupal.behaviors.pageHeroVideoPlayer = {
    attach: function (context, settings) {
      $(once('node-hero-video-player', '.node--type-page.node--view-mode-full', context)).each(function (index) {
        if (typeof drupalSettings.videoPlayer !== 'undefined') {
          var nodeId = 'node_' + $(this).attr('data-entity-id');
          var playerInfo = drupalSettings.videoPlayer['' + nodeId + ''];
          var modalId = 'modal-' + $(this).attr('data-entity-id');
          var modal = $(this).find('.hero-video-player__modal').attr('data-modal', modalId);
          var closeButton = $(this).find('.hero-video-player__modal-close-button').attr('data-modal', modalId);
          var videoPlayerPlayButton = $(this).find('.hero-video-player__play-button');
          if (playerInfo.video_provider === 'youtube') {
            var playerId = 'player-' + $(this).attr('data-entity-id');
            var videoPlayerContainer = $(this).find('.hero-video-player__video-container');
            videoPlayerContainer.attr('id', playerId);
            // This function creates an <iframe> (and YouTube player)
            // after the API code downloads.
            var player;
            // eslint-disable-next-line no-inner-declarations
            function onYouTubeIframeAPIReady() {
              // eslint-disable-next-line no-undef
              player = new YT.Player('' + playerId + '', {
                height: playerInfo.video_height,
                width: playerInfo.video_width,
                videoId: playerInfo.video_id,
                events: {
                  onReady: onPlayerReady, // eslint-disable-line
                }
              });
            }
            // eslint-disable-next-line no-inner-declarations
            function onPlayerReady(event) {
              // bind events
              videoPlayerPlayButton.bind('click', function () {
                modal.css('display', 'flex');
                player.playVideo();
              });
            }
            window.YT.ready(function () {
              onYouTubeIframeAPIReady();
            });
            closeButton.bind('click', function () {
              modal.css('display', 'none');
              player.stopVideo();
              player.destroy();
              player = null;
              onYouTubeIframeAPIReady();
            });
            modal.bind('click', function () {
              if (modal.css('display') === 'flex') {
                modal.css('display', 'none');
                player.stopVideo();
                player.destroy();
                player = null;
                onYouTubeIframeAPIReady();
              }
            });
          }
          else if (playerInfo.video_provider === 'vimeo') {
            var vimeoPlayerId = 'player-' + $(this).attr('data-entity-id');
            var vimeoVideoPlayerPlayButton = $(this).find('.hero-video-player__play-button');
            var vimeoVideoPlayerContainer = $(this).find('.hero-video-player__video-container');
            vimeoVideoPlayerContainer.find('iframe').attr('data-entity-id', vimeoPlayerId);
            var vimeoIframe = $('#' + vimeoPlayerId + '')[0];
            // eslint-disable-next-line no-undef
            var vimeoPlayer = new Vimeo.Player(vimeoIframe);
            vimeoVideoPlayerPlayButton.bind('click', function () {
              modal.css('display', 'flex');
            });
            closeButton.bind('click', function () {
              modal.css('display', 'none');
              vimeoPlayer.pause();
              vimeoPlayer.unload();
            });
          }
        }
      });
    }
  };
})(jQuery, Drupal);
